// extracted by mini-css-extract-plugin
export default {"title-week":"style_title-week__Xmacf"};